import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player/lazy';
import PromptModal from '@wix/da-ds/pkg/modals/dsPresets/PromptModal';
const DaVideoPopup = ({ onSubmit, onCancel })=>{
    const { t } = useTranslation('editor');
    const validateInput = (value)=>{
        return !ReactPlayer.canPlay(value) ? t('ext.video.modal.input.error') : undefined;
    };
    return /*#__PURE__*/ React.createElement(PromptModal, {
        isOpen: true,
        title: t('ext.video.modal.title'),
        inputLabel: t('ext.video.modal.input.label'),
        inputPlaceholder: t('ext.video.modal.input.placeholder'),
        onInputValidate: validateInput,
        onCancel: onCancel,
        onDone: onSubmit,
        minLength: 1
    });
};
DaVideoPopup.displayName = 'DaVideoPopup';
export default DaVideoPopup;

//# sourceMappingURL=DaVideoPopup.js.map